import {createBrowserRouter, Navigate, NavigateProps} from "react-router"
import React from "react"
import {dashboardStore, kpiCustomerStore, navigationStore, tenantStore} from "./store"

import {observer} from "mobx-react";

import {fms} from "./routes"
import {cms} from "./routes/cms";
import {sls} from "./routes/sls";
import {pms} from "./routes/pms";
import {ErrorPage} from "./components/page";
import {vda} from "./routes/vda";
import {sca} from "./routes/sca";
import {sts} from "./routes/sts";
import {vhs} from "./routes/vhs";
import {ums} from "./routes/ums";
import {DashboardApp} from "./components/app";
import {sea} from "./routes/sea";

const LoginRedirect = observer(function LoginRedirect() {
    return <Navigate to={`/dashboard`} replace={true}/>
})

const TenantNavigate = observer(function TenantNavigate(props: NavigateProps) {
    return <Navigate {...props} to={`${tenantStore.path}${props.to}`}/>
})

const basePath = process.env.PUBLIC_URL

class RProvider {
    private _router: any = null
    get router() {
        const base = tenantStore.path
        if (this._router === null) {
            this._router = createBrowserRouter([
                {
                    path: '',
                    element: <TenantNavigate to={`/dashboard`} replace={true}/>,
                    errorElement: <ErrorPage/>
                },
                {
                    path: basePath,
                    element: <TenantNavigate to={`/dashboard`} replace={true}/>,
                    errorElement: <ErrorPage/>,
                    loader: async ({request}) => {
                        navigationStore.setActivePath(request)
                        return null
                    },
                },
                {
                    path: `/error`,
                    element: <ErrorPage/>,
                    errorElement: <ErrorPage/>,
                    loader: async ({request}) => {
                        navigationStore.setActivePath(request)
                        return null
                    },
                },
                {
                    path: `/login_redirect/*`,
                    element: <LoginRedirect/>,
                    errorElement: <ErrorPage/>
                },
                {
                    path: `/dashboard`,
                    element: <DashboardApp/>,
                    errorElement: <ErrorPage/>,
                    loader: async ({request}) => {
                        const searchParams = new URL(request.url).searchParams

                        dashboardStore.toRelative = searchParams.get('toRelative') || undefined
                        dashboardStore.fromAbsolute = searchParams.get('fromAbsolute') || undefined
                        dashboardStore.fromRelative = searchParams.get('fromRelative') || undefined
                        dashboardStore.toAbsolute = searchParams.get('toAbsolute') || undefined
                        dashboardStore.customerId = searchParams.get('customerId') || undefined

                        await Promise.all([
                            dashboardStore.load(),
                            kpiCustomerStore.init()
                        ]).catch(() => {}) // we must catch since we don't want to show the error page

                        navigationStore.setActivePath(request)
                        return null
                    },
                },
                // CMS
                ...cms,
                // SLS
                ...sls,
                // PMS
                ...pms,
                // FMS
                ...fms,
                // VDA
                ...vda,
                // SCA
                ...sca,
                // STS
                ...sts,
                // VHS
                ...vhs,
                // UMS
                ...ums,
                // SEA
                ...sea
            ], {
                basename: base
            })
        }
        return this._router
    }
}

const provider = new RProvider()

export {
    provider
}
